import { AxiosRequestConfig } from "axios";

import { IKeyPair } from "../../common/types/types";

export const addJWTInConfig = (
	oldconfig: AxiosRequestConfig | undefined,
	jwt: string
): AxiosRequestConfig => {
	if (!jwt) return oldconfig || {};

	return {
		...oldconfig,
		headers: {
			...oldconfig?.headers,
			Authorization: `Bearer ${jwt}`,
		},
	};
};

export const objectToArray = (params: IKeyPair<string>): string[] => {
	const values: string[] = [];
	const keys = Object.keys(params);

	for (const key of keys) {
		values.push(key, params[key]);
	}

	return values;
};
